import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl} from '../Univ.js';
function PharmPRList() {
    const [prData, setPrData] = useState([]);
    useEffect(() => {
        fetchPRData();
    }, []);
    function fetchPRData() {
        axios.get(`${baseUrl}pharm-purchase-request-search/`)
            .then(response => {
                const transformedData = response.data.map(item => ({
                    id: item.id,
                    pr_no: item.pr_no,
                    dept: item.dept,
                    requested_by: item.requested_by,
                    request_date: item.request_date,
                    status: item.status,
                    remarks: item.remarks,
                    products: item.products,
                    qtys: item.qtys,
                    action: (
                        <Link
                            to={`/pharm-purchase-request-view/${item.id}/`}
                            className="btn btn-success btn-sm"
                        >
                            View
                        </Link>
                    )
                }));
                setPrData(transformedData);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 80
        },
        {
            field: 'pr_no',
            headerName: 'PR No',
            width: 150
        },
        {
            field: 'request_date',
            headerName: 'PR Date',
            width: 130
        },
        {
            field: 'requested_by',
            headerName: 'Requested By',
            width: 180
        },
        {
            field: 'products',
            headerName: 'Products',
            width: 400,
            renderCell: (params) => (
                <div
                    style={{
                        whiteSpace: 'normal',
                        lineHeight: '20px',
                        paddingTop: '10px',
                        paddingBottom: '10px'
                    }}
                >
                    {params.row.products}
                </div>
            )
        },
        {
            field: 'qtys',
            headerName: 'Qty',
            width: 150
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 120,
            renderCell: (params) => (
                <span
                    className={
                        params.value === 'Approved'
                            ? 'badge bg-success'
                            : params.value === 'Rejected'
                                ? 'badge bg-danger'
                                : 'badge bg-warning text-dark'
                    }
                >
          {params.value}
        </span>
            )
        }
    ];
    return (
        <section className="container mt-4">

            <div className="row">

                <h3
                    className="text-center"
                    style={{
                        color: 'black',
                        backgroundColor: '#e5eaef',
                        padding: '10px'
                    }}
                >
                    <i
                        className="fa-solid fa-list"
                        aria-hidden="true"
                        style={{color: 'red'}}
                    ></i>

                    {' '}Purchase Request List

                </h3>

                {prData.length > 0 ? (
                    <div
                        style={{
                            height: '100%',
                            width: '100%'
                        }}
                        className="mt-4"
                    >

                        <DataGrid

                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={prData}
                            columns={columns}
                            pageSize={10}
                            slots={{toolbar: GridToolbar}}
                            autoHeight
                            initialState={{
                                sorting: {
                                    sortModel: [{field: 'id', sort: 'desc'}],
                                },
                            }}

                        />

                    </div>
                ) : (
                    <div className="text-center mt-5">

                        <h5>No Purchase Requests Found</h5>

                    </div>
                )}

            </div>

        </section>
    );
}
export default PharmPRList;